import { LOAD_COMPANY } from '@vue-app/store/const/actions-types'

export const companyMiddleware = async ({ to, store }) => {
  if (to.params.id && !store.getters.companyLoaded(to.params.id)) {
    await store.dispatch(LOAD_COMPANY, to.params.id)
  }
}
